import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { CreatorResponseDto } from '../../../../../common/general-types/creators.dto';
import { SuperSocialService } from '../../../../../services/super-social/super-social.service';
import { SocialPlatformsEnum } from '../../../../../common/general-types/super-social.dto';
import { GenericPostsDto } from '../../../../../common/general-types/super-social.dto';
import { FormatService } from '../../../../../common/format/format.service';
import { ImageService } from '../../../../../services/image/image.service';
import { MediaViewerSimplerComponent } from '../../../../../atoms/media-viewer-simpler/media-viewer-simpler.component';
import { LdgImgComponent } from '../../../../../atoms/ldg-img/ldg-img.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HasRoleDirectiveDirective } from '../../../../../common/directives/has-role/has-role-directive.directive';
import { ToastNotificationService } from '../../../../../atoms/toast-notification/toast-notification.service';
import { CurrentUserService } from '../../../../../common/current-user/current-user.service';
import { UltraSocialService, UltraSocialSocialAccount } from '@/app/services/ultra-social/ultra-social';
import { forkJoin, Observable, take } from 'rxjs';
import { VideoResponseDto } from '@/app/common/general-types/videos.dto';
import { VideoFormatEnum } from '@/app/common/general-types/briefs.dto';
import { MgcPortfolioInlineVideoComponent } from '../mgc-portfolio/mgc-portfolio-inline-video.component';
import { LoadingInlineComponent } from '@/app/atoms/loading-inline/loading-inline.component';
import { DialogComponent } from '@/app/atoms/dialog/dialog.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

type UltraInstagramPost = {
  assetImageKeys: string[] | null;
  assetImageUrls: string[] | null;
  assetMediaKey: string | null;
  assetMediaUrl: string | null;
  assetThumbnailKey: string | null;
  assetThumbnailUrl: string | null;
  caption: string | null;
  commentCount: number;
  id: string;
  likeCount: number;
  permalink: string;
  postedAt: Date;
  shareCount: number;
  thumbnailUrl: string | null;
  type: string;
  viewCount: number;
};

type InstagramShortcode = {
  shortcode: string;
  kind: 'p' | 'reel';
};

type InstagramPlayback = {
  nativeUrl?: string;
  embedSrc?: SafeResourceUrl;
  watchUrl?: string;
};

@Component({
  selector: 'mgc-instagram',
  standalone: true,
  imports: [
    LdgImgComponent,
    DecimalPipe,
    HasRoleDirectiveDirective,
    DatePipe,
    MediaViewerSimplerComponent,
    MgcPortfolioInlineVideoComponent,
    LoadingInlineComponent,
    DialogComponent,
  ],
  templateUrl: './mgc-instagram.component.html',
  styleUrl: './mgc-instagram.component.css'
})
export class MgcInstagramComponent implements OnInit {
  @Input() creator!: CreatorResponseDto;
  @Input() ultra_social_instagram: UltraSocialSocialAccount | undefined;
  @Input() ultra_social_creator_id: string | undefined;

  instagramBasics = signal<{
    instagram_account_id: string;
    creatorId: string;
    handle: string;
    bio: string;
    name: string;
    profile_picture_url: string;
    followers_count: number;
    follows_count: number;
    media_count: number;
    createdDate: Date;
    updatedDate: Date;
    apifyContentScrapingLastLimitedAt: Date | null;
    apifyContentScrapingLastUnlimitedAt: Date | null;
    apifyContentScrapingLimited: boolean;
  } | undefined>(undefined);


  instagramInsights = signal<any>(undefined);
  instagramPosts = signal<GenericPostsDto[] | undefined>(undefined);

  refreshInstagramAccountLoading = signal<boolean>(false);
  accountRefreshed = signal<boolean>(false);

  /** Ultra Social */
  utlra_instagram_account = signal<{
    id: string;
    platform: "tiktok" | "instagram" | "youtube" | "snapchat";
    handle: string;
    displayName: string;
    avatarUrl: string;
    bio: string | null;
    status: string | null;
    followerCount: number;
    followingCount: number;
    likesCount: number;
    postCount: number;
  } | undefined>(undefined);

  utlra_instagram_posts = signal<UltraInstagramPost[] | undefined>(undefined);
  /** Ultra Social END */

  SocialPlatformsEnum = SocialPlatformsEnum;

  readonly instagramHandleRevealed = computed(() => this.currentUserService.subscriptionActive());
  readonly instagramPlayback = signal<InstagramPlayback | null>(null);
  readonly instagramEmbedOpen = computed(() => !!this.instagramPlayback());
  readonly instagramNativeUrl = computed(() => this.instagramPlayback()?.nativeUrl);
  readonly instagramEmbedSrc = computed(() => this.instagramPlayback()?.embedSrc);
  readonly instagramWatchUrl = computed(() => this.instagramPlayback()?.watchUrl);

  /** Services */
  public superSocialService = inject(SuperSocialService);
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  public toastNotificationService = inject(ToastNotificationService);
  public currentUserService = inject(CurrentUserService);
  public ultraSocialService = inject(UltraSocialService);
  private readonly sanitizer = inject(DomSanitizer);
  /** Services - END */

  ngOnInit(): void {
    console.log('-----> ultra_social_tiktok', this.ultra_social_instagram);

    if (this.ultra_social_creator_id && this.ultra_social_instagram) {
      this.getUltraInstagramAccount(this.ultra_social_creator_id, this.ultra_social_instagram.id);
    }

    else if (this.creator && this.creator.ssCreator && this.creator.ssCreator.instagramAccountId) {
      this.getSuperSocialInstagramAccount(this.creator.ssCreator.instagramAccountId);
      // this.getSuperSocialInstagramInsights(this.creator.ssCreator.instagramAccountId); --> This guy throws errors for days.
      this.getSuperSocialInstagramPosts(this.creator.ssCreator.instagramAccountId);


      // this.getInsightsDashboard(this.creator.ssCreator.instagramAccountId);
    }
  }

  /**
   * 
   * @param instagramAccountId 
   * 
   * Only good for accounts connected via Authentic IG API.
   */
  getInsightsDashboard(instagramAccountId: string) {
    this.superSocialService.getInsightsDashboard(instagramAccountId).subscribe((superSocialInstagramAccount) => {
      console.log('-----> getInsightsDashboard: ', superSocialInstagramAccount);
      this.instagramBasics.set(superSocialInstagramAccount);
    });
  }






  getSuperSocialInstagramAccount(instagramAccountId: string) {
    this.superSocialService.getSuperSocialInstagramAccount(instagramAccountId).subscribe((superSocialInstagramAccount) => {
      console.log('Super Social Instagram Account: ', superSocialInstagramAccount);
      this.instagramBasics.set(superSocialInstagramAccount);
    });
  }

  getSuperSocialInstagramInsights(instagramAccountId: string) {
    this.superSocialService.readInstagramInsightsDashboard(instagramAccountId).subscribe((superSocialInstagramInsights) => {
      console.log('Super Social Instagram Insights: ', superSocialInstagramInsights);
      this.instagramInsights.set(superSocialInstagramInsights);
    });
  }

  getSuperSocialInstagramPosts(instagramAccountId: string) {
    this.superSocialService.getInstagramDisplayContent(instagramAccountId).subscribe((superSocialInstagramPosts) => {
      console.log('Super Social Instagram Posts: ', superSocialInstagramPosts);
      this.instagramPosts.set(superSocialInstagramPosts);
    });
  }

  getUltraInstagramAccount(ultra_social_creator_id: string, socialAccountId: string) {
    this.loadData(ultra_social_creator_id, socialAccountId).pipe(take(1)).subscribe((data) => {
      console.log('ULTRA data', data);
      this.utlra_instagram_account.set(data.account);
      this.utlra_instagram_posts.set(data.posts);
    });
  }

  private loadData(ultra_social_creator_id: string, socialAccountId: string): Observable<{
    account: any;
    posts: any[];
  }> {
    return forkJoin({
      account: this.ultraSocialService.getSocialAccount(ultra_social_creator_id, socialAccountId),
      posts: this.ultraSocialService.getAccountPosts(ultra_social_creator_id, socialAccountId),
    });
  }

  getCoverImage(post: GenericPostsDto): string {
    return this.getUsableCoverUrl(post) ?? '/assets/images/placeholder-video.png';
  }

  getUsableCoverUrl(post: GenericPostsDto): string | undefined {
    const cover = post.instagramVideoFile?.cover;
    if (this.isUsableMediaUrl(cover)) {
      return cover;
    }
    const carouselUrl = post.instagramCarouselFile?.images?.[0]?.s3_url;
    if (this.isUsableMediaUrl(carouselUrl)) {
      return carouselUrl;
    }
    if (this.isUsableMediaUrl(post.image)) {
      return post.image;
    }
    return undefined;
  }

  superSocialInstagramVideoUrl(post: GenericPostsDto): string {
    return post.instagramVideoFile?.s3_url ?? '';
  }

  instagramShortcodeFromSource(source: string | null | undefined): InstagramShortcode | undefined {
    if (!source) {
      return undefined;
    }
    const trimmed = source.trim();
    const fromPath = trimmed.match(
      /instagram\.com\/(?:[^/?#]+\/)?(reel|reels|p|tv)\/([A-Za-z0-9_-]+)/i,
    );
    if (fromPath) {
      const kind = fromPath[1].toLowerCase() === 'p' ? 'p' : 'reel';
      return { shortcode: fromPath[2], kind };
    }
    if (/^[A-Za-z0-9_-]{5,20}$/.test(trimmed)) {
      return { shortcode: trimmed, kind: 'reel' };
    }
    return undefined;
  }

  superSocialInstagramShortcode(post: GenericPostsDto): InstagramShortcode | undefined {
    const fromUrl =
      this.instagramShortcodeFromSource(post.instagramVideoFile?.original_url) ??
      this.instagramShortcodeFromSource(post.instagramCarouselFile?.original_url) ??
      this.instagramShortcodeFromSource(post.url);
    if (fromUrl) {
      return fromUrl;
    }
    const fromCode =
      this.instagramShortcodeFromSource(post.instagramVideoFile?.shortcode) ??
      this.instagramShortcodeFromSource(post.instagramCarouselFile?.shortcode);
    if (!fromCode) {
      return undefined;
    }
    return {
      shortcode: fromCode.shortcode,
      kind: post.instagramVideoFile ? 'reel' : 'p',
    };
  }

  canPlaySuperSocialInstagram(post: GenericPostsDto): boolean {
    return !!(this.superSocialInstagramVideoUrl(post) || this.superSocialInstagramShortcode(post));
  }

  ultraInstagramShortcode(post: UltraInstagramPost): InstagramShortcode | undefined {
    return this.instagramShortcodeFromSource(post.permalink) ?? this.instagramShortcodeFromSource(post.id);
  }

  canPlayUltraInstagram(post: UltraInstagramPost): boolean {
    return !!(post.assetMediaUrl || this.ultraInstagramShortcode(post));
  }

  openSuperSocialInstagram(post: GenericPostsDto): void {
    this.instagramPlayback.set(this.buildPlayback({
      nativeUrl: this.superSocialInstagramVideoUrl(post) || undefined,
      parsed: this.superSocialInstagramShortcode(post),
    }));
  }

  openUltraInstagram(post: UltraInstagramPost): void {
    this.instagramPlayback.set(this.buildPlayback({
      nativeUrl: post.assetMediaUrl || undefined,
      parsed: this.ultraInstagramShortcode(post),
    }));
  }

  closeInstagramEmbed(): void {
    this.instagramPlayback.set(null);
  }

  private buildPlayback(input: {
    nativeUrl?: string;
    parsed?: InstagramShortcode;
  }): InstagramPlayback | null {
    const watchUrl = input.parsed
      ? `https://www.instagram.com/${input.parsed.kind}/${input.parsed.shortcode}/`
      : undefined;
    const embedSrc = input.parsed
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://www.instagram.com/${input.parsed.kind}/${input.parsed.shortcode}/embed/`,
        )
      : undefined;
    if (!input.nativeUrl && !embedSrc) {
      return null;
    }
    return {
      nativeUrl: input.nativeUrl,
      embedSrc,
      watchUrl,
    };
  }

  private isUsableMediaUrl(url: string | null | undefined): url is string {
    if (!url) {
      return false;
    }
    return !url.includes('ionicframework.com/docs/img/demos/thumbnail.svg');
  }

  refreshInstagramAccount() {
    console.log('-----> refreshInstagramAccount');
    this.refreshInstagramAccountLoading.set(true);

    if (this.creator.ssCreator && this.creator.ssCreator.instagramAccountId && (this.creator.ssCreator.instagramSource === 'apify' || !this.creator.ssCreator.instagramSource)) {
      this.superSocialService.refreshInstragramApify(this.creator.ssCreator.instagramAccountId).subscribe((refreshSent) => {
        console.log('refreshSent: ', refreshSent);
        this.refreshInstagramAccountLoading.set(false);
        this.accountRefreshed.set(true);
      }, err => {
        console.error('Error refreshing Instagram account: ', err);
        this.refreshInstagramAccountLoading.set(false);
        void this.toastNotificationService.alert({
          title: 'Error Refreshing Instagram Account!',
          message: 'Something went wrong. If the problem persists, please contact support.',
          type: 'error',
          icon: 'error'
        });
      });
    } else if (this.creator.ssCreator && this.creator.ssCreator.instagramAccountId && this.creator.ssCreator.instagramSource === 'tiktokapi') {
      this.superSocialService.refreshInstragramAuthentic(this.creator.ssCreator.instagramAccountId).subscribe((refreshSent) => {
        console.log('refreshSent: ', refreshSent);
        this.refreshInstagramAccountLoading.set(false);
        this.accountRefreshed.set(true);
      }, err => {
        console.error('Error refreshing Instagram account: ', err);
        this.refreshInstagramAccountLoading.set(false);
        void this.toastNotificationService.alert({
          title: 'Error Refreshing Instagram Account!',
          message: 'Something went wrong. If the problem persists, please contact support.',
          type: 'error',
          icon: 'error'
        });
      });
    }
  }

  allowedToRefreshInstagramAccount(updatedDate: Date): boolean {
    if (updatedDate) {
      const hoursAgo = Math.floor((new Date().getTime() - new Date(updatedDate).getTime()) / (1000 * 60 * 60));
      if (hoursAgo < 12) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  getUpdatedDateColour(updatedDate: Date): string {
    if (updatedDate) {
      const hoursAgo = Math.floor((new Date().getTime() - new Date(updatedDate).getTime()) / (1000 * 60 * 60));
      if (hoursAgo < 12) {
        return 'text-green-500';
      } else if (hoursAgo < 24) {
        return 'text-primary';
      } else if (hoursAgo < 48) {
        return 'text-amber-500';
      }
      else {
        return 'text-red-500';
      }
    }
    return 'text-gray-500';
  }

  assembledVideoObject(post: UltraInstagramPost): VideoResponseDto {
    return {
      createdDate: post.postedAt,
      creator: this.creator,
      creatorId: this.creator.blazeFirebaseUid,
      fullUrl: post.assetMediaUrl ? post.assetMediaUrl : '',
      id: post.id,
      key: post.assetMediaKey ? post.assetMediaKey : '',
      status: 1,
      thumbnail: post.thumbnailUrl ? post.thumbnailUrl : '',
      ugcBriefApplicationId: null,
      videoFormat: VideoFormatEnum.Horizontal,
      videoLength: 0,
      videoName: post.caption ? post.caption : '',
      briefApplicationId: '',
      thumbnailURL: post.thumbnailUrl ? post.thumbnailUrl : '',
    }
  }
}
